import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { getToken, setToken, setUnauthorizedHandler } from "@/lib/adminApi";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminHeader } from "@/components/admin/AdminHeader";
import { VendorPricingTab } from "@/components/admin/VendorPricingTab";
import { ContactMessagesTab } from "@/components/admin/ContactMessagesTab";
import { InquiriesTab } from "@/components/admin/InquiriesTab";
import { TodosTab } from "@/components/admin/todos/TodosTab";
import "@/styles/todos.css";
import "@/styles/hausa-vendor.css";

const TRIGGER = "rounded-none bg-transparent px-0 pb-3 pt-0 text-[15px] font-semibold text-[#6B7A75] border-b-2 border-transparent -mb-px shadow-none data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=active]:text-[#1F2A27] data-[state=active]:border-[#5A776F]";

export default function AdminDashboard() {
  const [token, setTok] = useState(getToken());

  const logout = () => { setToken(null); setTok(null); };

  useEffect(() => {
    document.title = "Admin | hausA Interior Design Studio";
    setUnauthorizedHandler(() => {
      if (getToken()) toast.error("Session expired. Please sign in again.");
      logout();
    });
  }, []);

  if (!token) {
    return (
      <>
        <AdminLogin onLogin={(t) => { setToken(t); setTok(t); }} />
        <Toaster position="bottom-right" />
      </>
    );
  }

  return (
    <div className="hx" data-testid="admin-dashboard">
      <AdminHeader onLogout={logout} />
      <main className="hx-container hx-container--wide hx-admin-main">
        <Tabs defaultValue="vendor">
          <TabsList className="h-auto w-full justify-start gap-6 sm:gap-8 overflow-x-auto overflow-y-hidden rounded-none border-b border-[#E3E7E5] bg-transparent p-0" style={{ fontFamily: "Outfit, sans-serif" }}>
            <TabsTrigger value="vendor" className={TRIGGER} data-testid="admin-tab-vendor-pricing">Vendor Pricing</TabsTrigger>
            <TabsTrigger value="inquiries" className={TRIGGER} data-testid="admin-tab-inquiries">Inquiries</TabsTrigger>
            <TabsTrigger value="contact" className={TRIGGER} data-testid="admin-tab-contact-messages">Contact Messages</TabsTrigger>
            <TabsTrigger value="todos" className={TRIGGER} data-testid="admin-tab-todos">To-Dos</TabsTrigger>
          </TabsList>
          <TabsContent value="vendor"><VendorPricingTab /></TabsContent>
          <TabsContent value="inquiries"><InquiriesTab /></TabsContent>
          <TabsContent value="contact"><ContactMessagesTab /></TabsContent>
          <TabsContent value="todos"><TodosTab /></TabsContent>
        </Tabs>
      </main>
      <Toaster position="bottom-right" />
    </div>
  );
}
